const placeholder = {
  text: {
    isNotNUll:'Data cannot be null!',//数据不能为空
    verifyValue:'Enter the NFC card number',//请输入NFC卡号
    port:'Please enter a port number',//
    ip:'Please enter the IP',//请输入ip
    agreementId:'Please enter the GPS device ID',//请输入gps设备id
    manuId:'Please enter the manufacturer ID',//请输入制造商id
    default: "Input",//请输入
    account: "Input account",//请输入账号
    phone: "Input phone",//请输入手机号
    telPhone: "Input Tel",//请输入固定电话！
    name: "Input name",//请输入名称
    imei:"Input imei",//请输入imei
    groupName:"Input Group Name",//请输入群组名称
    groupId:'Input Group Id',
    domainName: "Input domain name",//请输入域名
    identification: "Input ID Card",//请输入合法身份证号码
    companyName: "Input company name",//请输入公司名称
    password: "Input password",//请输入密码
    eamil: "Input email",//请输入邮箱
    remark: "Input remark",//请输入备注
    rangeSeparator:'-',
    startDate:'Start date',//开始日期
    endDate:'End date',//结束日期
    iccid:'Input iccid',//请输入iccid
    begin:'Input being data',//请输入始数据
    end:'Input end data',//请输入末数据
    common:'Please Enter Public Data',//请输入公共数据
    flagData:'Please enter identification data',//请输入标识数据
    startData:'Please enter the starting value of ICCID', //请输入起始iccid
    endData:'Please enter the ending value of ICCID',//请输入结束iccid
    startAccount:'Please enter the account start data',//请输入账号开始数据
    imeiStart:'The begin part is 2-5 digits long',//请输入2-5位起始数据
    imeiEnd:'The end part is 2-5 digits long',//请输入2-5位结束数据
    imeiCommin:'The common part is 9-12 digits long',//请输入账号开始数据

    year:"year",// "请选择年"
    season:"season",//"选择季度"
    orderId:'Please enter the starting value of orderId',
    noDinding:"no bind",
    talkie:"对讲价格",//对讲价格
    F2F:"1个群组的基础价格",
    dispatch:"调度价格",//调度价格
    record:"录音存储1个月",//录音存储1个月
    record1:"录音存储3个月",//录音存储3个月
    record2:"录音存储6个月",//录音存储6个月
    record3:"录音存储一年",//录音存储一年
    location:"定位存储7天",//定位存储7天
    location1:"定位存储1个月",//定位存储1个月
    location2:"定位存储3个月",//定位存储3个月
    location3:"定位存储6个月",//定位存储6个月
    location4:"定位存储一年",//定位存储一年
    broadcast:"广播",//广播

  },
  select: {
    default: "Select",//请选择
    status: "Select status",//请选择状态
    proxy: "Select agent",//请选择代理
    enterprise: "Select company",//请选择企业
    subagent: 'Select subagent',//请选择子代理
    domainName: "Select domain name",//请选择域名
    permission: "Select user right type",//请选择权限类型
    groupType: "Select group type",//请选择群组类型
    secondaryManagement: "Select secondary account MGT"//请选择二级管理
  }
};
export default placeholder;



// WEBPACK FOOTER //
// ./src/api/lang/modules/placeholder/placeholder_en.js